<template>
  <div>
    <MQ mq="desktop">
      <DesktopBtnSelectWashVial v-bind="$props" v-on="$listeners">
        <slot />
      </DesktopBtnSelectWashVial>
    </MQ>
    <MQ mq="mobile">
      <MobileBtnSelectWashVial v-bind="$props" v-on="$listeners">
        <slot />
      </MobileBtnSelectWashVial>
    </MQ>
  </div>
</template>

<script>
  import { props } from '@/uikitProject/vials/vueBtnSelectWashVial/shared/config.ts';

  export default {
    name: 'BtnSelectWashVial',

    components: {
      DesktopBtnSelectWashVial: () => import('./desktop/BtnSelectWashVial.desktop'),
      MobileBtnSelectWashVial: () => import('./mobile/BtnSelectWashVial.mobile'),
    },

    props,
  };
</script>
